import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { GsfService } from './gsf.service';

angular.module('app-lite.gsf', [])
.service('gsfApi', downgradeInjectable(GsfService));